<template>
  <div>
    <div @click.stop="close()" class="dialogShadow"></div>
    <dl ref="dialogBody" class="dialogBody ub-box ub-col">
      <dd class="dialogTitle z-font-size-16">
        <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
        <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
      </dd>
      <dd class="dialogContent z-color-666 z-font-size-15 ub-box">
        <div>
          <img v-if="type === 'success'" style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_success.png" alt="">
          <img v-if="type === 'error'" style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        </div>
        <div class="z-font-size-15 z-lineHeight-40">
          {{info}}
        </div>
      </dd>
      <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
        <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
        <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
      </div>
    </dl>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        flag:false
      }
    },
    mounted() {
      if(this.type === 'success' ){
        setTimeout(() => {
          //关闭后就不自动关闭了
          if(!this.flag){
            this.clickBtn()
          }
        },2000)
      }
    },
    methods:{
      close(){
        document.body.removeChild(this.$el)
      },
      clickBtn(){
        this.flag = true
        document.body.removeChild(this.$el)
        this.click()
      }
    }
  }
</script>
<style scoped="scoped">
  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/dialog.vue